import { create } from "zustand";
import { closeOtherModals, registerModalStore } from "./modal-registry";

/** Key this store is known by in the modal registry. */
const MODAL_NAME = "invite-friend";

export const useInviteFriendModalStore = create((set) => ({
  isModalOpen: false,
  inviteFriendUrl: null,
  openModal: (url) => {
    closeOtherModals(MODAL_NAME);

    set({ isModalOpen: true, inviteFriendUrl: url });
  },
  closeModal: () => set({ isModalOpen: false, inviteFriendUrl: null }),
  updateIsModalOpen: (isModalOpen) => set({ isModalOpen }),
}));

registerModalStore(MODAL_NAME, useInviteFriendModalStore);
